// @flow

export const NAV_HEIGHT_DESKTOP = 68;
export const NAV_HEIGHT_MOBILE = 52;

export const Z_INDEX_DESKTOP_NAV = 100;
export const Z_INDEX_MOBILE_CTA_BAR = 110;
export const Z_INDEX_MOBILE_MENU = 115;
export const Z_INDEX_MOBILE_NAV_BAR = 120;
